export const LIVEKIT_PROVIDER = 'livekit';

// Announced once this client is fully connected, so the doctor's app can tell "the room
// accepted the patient" (which fires mid-handshake, while this screen is still loading)
// apart from "the patient is actually here".
export const PATIENT_READY_TOPIC = 'telemedicine:patient-ready';

// LiveKit identities come from telemedicine-api: `user_<id>` for the doctor, `patient_<id>` for
// the patient - the GUS bot has its own prefix, so it is never mistaken for the doctor.
const DOCTOR_IDENTITY_PREFIX = 'user_';

export const isDoctorIdentity = identity => !!identity?.startsWith(DOCTOR_IDENTITY_PREFIX);
